//@flow
import * as Immutable from 'immutable';

import { FpPointsLatLng, FpBeat } from 'common/models/flow/FpBeat';
import type {
    FpPointsLatLngModelType,
    FpBeatModelType
} from 'common/models/flow/FpBeat';

class InternalFpPointsLatLng extends FpPointsLatLng {
    static fromJS(json: FpPointsLatLngModelType): InternalFpPointsLatLng {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalFpBeat extends FpBeat {
    static fromJS(json: FpBeatModelType): InternalFpBeat {
        const state: Object = Object.assign({}, json);
        state.categories = Immutable.List(state.categories);
        state.visits = Immutable.List(state.visits);
        return new this(Immutable.Map(state));
    }
}

export { InternalFpPointsLatLng as FpPointsLatLng, InternalFpBeat as FpBeat };
